<template>
    <div class="edit-button-vue" @click="handleClick">
        <img src="/media/images/pen_white.svg" />
        <div class="edit-button-vue-line-left"></div>
    </div>
</template>

<script>
export default {
    name: "EditButton",
    props: {
        route: String,
        onClick: Function,
    },
    methods: {
        handleClick(event) {
            if (this.route) {
                this.$router.push(this.route);
            } else if (this.onClick) {
                this.onClick(event);
            }
        },
    },
};
</script>

<style scoped>
.edit-button-vue {
    background-color: #41abc4;
    width: 34px;
    height: 34px;
    border-radius: 4px;
    padding: 6px;
    position: relative;
    display: inline-block;
}

.edit-button-vue:hover {
    cursor: pointer;
}

.edit-button-vue > img {
    width: 23px;
    position: relative;
    display: block;
}

.edit-button-vue-line-left {
    width: 0;
    height: 2px;
    position: absolute;
    background: #ffffff;
    transition: width 0.5s;
    bottom: 0;
    left: 0;
    bottom: 3px;
    left: 6px;
}

.edit-button-vue:hover .edit-button-vue-line-left {
    width: 26px;
}
</style>
